  let autocomplete;
  let address1Field;
  let address2Field;
  let postalField;
  let cityField;
  let country;

  function initAutocomplete() {
    var googleMaps =  google.maps;  
    country = document.querySelector('.adrs-popup-main.s-loopup-address #country');

    address1Field = document.querySelector(".adrs-popup-main.s-loopup-address #address1");
    address2Field = document.querySelector(".adrs-popup-main.s-loopup-address #address2");
    postalField = document.querySelector(".adrs-popup-main.s-loopup-address #postal_code");
    cityField = document.querySelector(".adrs-popup-main.s-loopup-address #city");

    autocomplete = new google.maps.places.Autocomplete(address1Field, {
      // componentRestrictions: { country: ["us", "ca"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    });
    
    googleMaps.event.addDomListener(country, 'input', function(){
      var countryCode = this.value.trim().toUpperCase();
      if(countryCode != null){
        autocomplete.setComponentRestrictions({country: countryCode});
      }       
    });
    googleMaps.event.trigger(country, 'input');

    address1Field.focus();
    autocomplete.addListener("place_changed", fillInAddress);
  }

  function fillInAddress() {
    const place = autocomplete.getPlace();
    let address1 = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }
        
        case "locality":
          cityField.value = component.long_name;
          break;

        case "administrative_area_level_1": {
          document.querySelector(".adrs-popup-main.s-loopup-address #state").value = component.short_name;
          break;
        }
      }
    }

    address1Field.value = address1;
    postalField.value = postcode;
    address2Field.focus();
  }
  
  window.initAutocomplete = initAutocomplete;